import React from "react";
import "./team.css";
// import { Row, Col } from "react-bootstrap";
import team1 from "../Assets/team1.png";
import staff1 from "../Assets/staff1.png"
import staff2 from "../Assets/staff2.png"
import staff3 from "../Assets/staff3.png"
import staff4 from "../Assets/staff4.png"
import staff5 from "../Assets/staff5.png"

const Team = () => {
  return (
    <div className="team-session">
      <div className="team-session-header">
        <h2>Our Team</h2>
      </div>

      <div className=" team-image ">
        <div className="image-sec">
          <img src={staff1} className="team-img mt-2" alt="" srcSet="" />
          <h3>Oluwabusola Ige</h3>
          <p>Human Resource Officer</p>
        </div>
        <div className="image-sec">
          <img src={staff2} className="team-img mt-2" alt="" srcSet="" />
          <h3>Oluwatosin Ogunleye</h3>
          <p>Developer</p>
        </div>{" "}
        <div className="image-sec">
          <img src={staff3} className="team-img mt-2" alt="" srcSet="" />
          <h3>Opeyemi Peters</h3>
          <p>Developer</p>
        </div>{" "}
        <div className="image-sec ">
          <img src={staff4} className="team-img mt-5" alt="" srcSet="" />
          <h3>Ifedayo Daramola</h3>
          <p>Sales Executive</p>
        </div>{" "}
        <div className="image-sec">
          <img src={staff5} className="team-img mt-5" alt="" srcSet="" />
          <h3>Oluwatosin Ebhohimen</h3>
          <p>Sales Executive</p>
        </div>{" "}
      </div>
    </div>
  );
};

export default Team;
